import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../components/auth/ProtectedRoute";
import { PharmacyRouteGuard } from "../components/auth/PharmacyRouteGuard";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { ContactPage } from "../pages/auth/ContactPage";
import { ForgotPasswordPage } from "../pages/auth/ForgotPasswordPage";
import { LoginPage } from "../pages/auth/LoginPage";
import { ResetPasswordPage } from "../pages/auth/ResetPasswordPage";
import { ImpersonationExchangePage } from "../pages/auth/ImpersonationExchangePage";
import { AccountDeletionPage } from "../pages/legal/AccountDeletionPage";
import { PrivacyPolicyPage } from "../pages/legal/PrivacyPolicyPage";
import { TermsPage } from "../pages/legal/TermsPage";
import { protectedAdvancedRoutes } from "./routeGroups/advancedRoutes";
import { protectedFoundationRoutes } from "./routeGroups/foundationRoutes";
import { protectedOperationsRoutes } from "./routeGroups/operationsRoutes";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/contact-us" element={<ContactPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/impersonation" element={<ImpersonationExchangePage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/account-deletion" element={<AccountDeletionPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<PharmacyRouteGuard />}>
          <Route element={<DashboardLayout />}>
            {protectedFoundationRoutes}
            {protectedOperationsRoutes}
            {protectedAdvancedRoutes}
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default AppRoutes;
